export const ContactPersonIcon = () => {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 14.318C4.75736 14.318 3.75 13.3106 3.75 12.068C3.75 10.8254 4.75736 9.81799 6 9.81799C6.17108 9.81799 6.33429 9.88321 6.47202 9.98471C6.96959 10.3514 7.58449 10.5681 8.25 10.5681H9.75C10.4155 10.5681 11.0304 10.3514 11.528 9.98471C11.6657 9.88321 11.8289 9.81799 12 9.81799C13.2426 9.81799 14.25 10.8254 14.25 12.068C14.25 13.3106 13.2426 14.318 12 14.318M10.125 15.0684L8.625 16.5684L7.875 15.8184M9 9.06836C7.34315 9.06836 6 7.72521 6 6.06836C6 4.41151 7.34315 3.06836 9 3.06836C10.6569 3.06836 12 4.41151 12 6.06836C12 7.72521 10.6569 9.06836 9 9.06836Z"
        stroke="#05796B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
